import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVStoreKeyMap } from './mmkvStoreKeyMap';

export const mmkvAppPersistence = new MMKV({
  id: MMKVStoreKeyMap.appSettings,
});

export const zustandAppStorage: StateStorage = {
  setItem(name: string, value: string) {
    return mmkvAppPersistence.set(name, value);
  },
  getItem(name: string) {
    const value = mmkvAppPersistence.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
    return mmkvAppPersistence.delete(name);
  },
};
